@if (chemistry) {
  @if (!isMobileView) {
    <div class="container">
      <div class="row margin-top-20">
        <div class="container col-50">
          <div class="row">
            <span class="bold identifier-label">{{
              translationService.getIdentifiersText()
            }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="identifier-label">{{
              translationService.getArticleNameText()
            }}</span>
            <span class="identifier-value">{{ chemistry.articleName }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="identifier-label">{{
              translationService.getBrandText()
            }}</span>
            <span class="identifier-value">{{ chemistry.brand }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="identifier-label">{{
              translationService.getModelSkuText()
            }}</span>
            <span class="identifier-value">{{
              chemistry.sku ?? translationService.getNaText()
            }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="identifier-label">{{
              translationService.getSerialNumberText()
            }}</span>
            <span class="identifier-value">{{
              chemistry.serial ?? translationService.getNaText()
            }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="identifier-label">{{
              translationService.getTypeText()
            }}</span>
            <span class="identifier-value">{{
              chemistry.type ?? translationService.getNaText()
            }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="identifier-label">{{
              translationService.getGs1IdentifierText()
            }}</span>
            <span class="identifier-value">{{
              chemistry.gs1Identifier ?? translationService.getNaText()
            }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="identifier-label">{{
              translationService.getBarcodeIdentifierText()
            }}</span>
            <span class="identifier-value">{{
              chemistry.barcodeIdentifier ?? translationService.getNaText()
            }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="identifier-label">{{
              translationService.getOtherArticleIdentifierText()
            }}</span>
            <span class="identifier-value">{{
              chemistry.otherArticleIdentifier ?? translationService.getNaText()
            }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="identifier-label">{{
              translationService.getArticleCategoryText()
            }}</span>
            <span class="identifier-value">{{
              chemistry.articleCategory ?? translationService.getNaText()
            }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="identifier-label">{{
              translationService.getCategoryNameText()
            }}</span>
            <span class="identifier-value">{{
              getCategoryDisplayValue(chemistry.categoryName)
            }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="identifier-label">{{
              translationService.getCategoryCodeText()
            }}</span>
            <span class="identifier-value">{{
              chemistry.categoryCode ?? translationService.getNaText()
            }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="identifier-label">{{
              translationService.getCodeDescriptionText()
            }}</span>
            <span class="identifier-value">{{
              chemistry.codeDescription ?? translationService.getNaText()
            }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="identifier-label">{{
              translationService.getProducedInCanadaText()
            }}</span>
            <span class="identifier-value">{{
              getProducedInCanadaString()
            }}</span>
          </div>
        </div>
        <div class="container col-50">
          <div class="row">
            <span class="bold characteristic-label">{{
              translationService.getCharacteristicsText()
            }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="characteristic-label">{{
              translationService.getDiameterText()
            }}</span>
            <span class="characteristic-value">{{ chemistry.diameter }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="characteristic-label">{{
              translationService.getWidthText()
            }}</span>
            <span class="characteristic-value">{{ chemistry.width }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="characteristic-label">{{
              translationService.getHeightText()
            }}</span>
            <span class="characteristic-value">{{ chemistry.height }}</span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="characteristic-label">{{
              translationService.getWeightText()
            }}</span>
            <span class="characteristic-value"
              >{{ chemistry.measureValue }}{{ chemistry.measureUnit }}</span
            >
          </div>
          @if (chemistry.safeUseInstructions) {
            <div class="row margin-top-70 gap-5">
              <span class="bold characteristic-label">{{
                translationService.getSafeUseInstructionsText()
              }}</span>
              <span class="characteristic-value">
                <a
                  class="dark-link-underline"
                  href="javascript:void(0)"
                  (click)="showSafeUseInstructions()"
                >
                  <span class="vertical-center-flex">
                    <span>{{
                      translationService.getSafeUseInstructionsText()
                    }}</span>
                    <mat-icon class="slant-arrow-icon">call_made</mat-icon>
                  </span>
                </a>
              </span>
            </div>
          }
          @if (chemistry.recyclingInstructions) {
            <div class="row margin-top-10 gap-5">
              <span class="bold characteristic-label">{{
                translationService.getRecyclingInstructionsText()
              }}</span>
              <span class="characteristic-value">
                <button
                  class="button-link"
                  (click)="
                    downloadAndShowDocument(chemistry.recyclingInstructions)
                  "
                >
                  <span>{{
                    translationService.getRecyclingInstructionsText()
                  }}</span>
                  <mat-icon class="slant-arrow-icon">call_made</mat-icon>
                </button>
              </span>
            </div>
          }

          @if (chemistry.safetyDataSheet) {
            <div class="row margin-top-10 gap-5">
              <span class="bold characteristic-label">{{
                translationService.getSafetyDataSheetText()
              }}</span>
              <span class="characteristic-value">
                <button
                  class="button-link"
                  (click)="downloadAndShowDocument(chemistry.safetyDataSheet)"
                >
                  <span>{{ translationService.getSafetyDataSheetText() }}</span>
                  <mat-icon class="slant-arrow-icon">call_made</mat-icon>
                </button>
              </span>
            </div>
          }
          <div class="row margin-top-10 gap-5">
            <span class="bold characteristic-label">{{
              translationService.getIngredientsText()
            }}</span>
            <span class="characteristic-value">
              <a
                class="dark-link-underline"
                href="javascript:void(0)"
                (click)="openProductIngredients(chemistry.id)"
                target="_blank"
              >
                <span class="vertical-center-flex">
                  <span>{{ translationService.getIngredientsText() }}</span>
                  <mat-icon class="slant-arrow-icon">call_made</mat-icon>
                </span>
              </a>
            </span>
          </div>
          <div class="row margin-top-10 gap-5">
            <span class="bold characteristic-label">{{
              translationService.getSubstancesOfConcernText()
            }}</span>
            <span class="characteristic-value">
              <a
                class="dark-link-underline"
                href="javascript:void(0)"
                (click)="showSubstancesOfConcern()"
              >
                <span class="vertical-center-flex">
                  <span>{{
                    translationService.getSubstancesOfConcernText()
                  }}</span>
                  <mat-icon class="slant-arrow-icon">call_made</mat-icon>
                </span>
              </a>
            </span>
          </div>

          <div class="row wrap margin-top-40">
            @for (ghs of chemistry.ghsClassifications; track ghs) {
              <img
                [ngSrc]="getGhsImgPath(ghs.code)"
                height="80"
                width="80"
                [alt]="ghs.name"
                [title]="ghs.name"
                [matTooltip]="ghs.name"
              />
            }
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="container">
      <div class="info-container-mobile">
        @if (isProduct) {
          <div class="row margin-top-20">
            <span class="bold x-large-font">{{
              translationService.getChemistryText()
            }}</span>
          </div>
          <div class="margin-top-20">
            <mat-divider></mat-divider>
          </div>
        }
        <div class="row margin-top-10">
          <span>{{ translationService.getArticleNameText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{ chemistry.articleName }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getBrandText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{ chemistry.brand }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getModelSkuText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{ chemistry.sku }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getSerialNumberText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{
            chemistry.serial ?? translationService.getNaText()
          }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getTypeText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{
            chemistry.type ?? translationService.getNaText()
          }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getGs1IdentifierText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{
            chemistry.gs1Identifier ?? translationService.getNaText()
          }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getBarcodeIdentifierText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{
            chemistry.barcodeIdentifier ?? translationService.getNaText()
          }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getOtherArticleIdentifierText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{
            chemistry.otherArticleIdentifier ?? translationService.getNaText()
          }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getArticleCategoryText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{
            chemistry.articleCategory ?? translationService.getNaText()
          }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getCategoryNameText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{
            chemistry.categoryName ?? translationService.getOtherText()
          }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getCategoryCodeText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{
            chemistry.categoryCode ?? translationService.getNaText()
          }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getCodeDescriptionText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{
            chemistry.codeDescription ?? translationService.getNaText()
          }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getProducedInCanadaText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{ getProducedInCanadaString() }}</span>
        </div>
      </div>
      <div class="info-container-mobile">
        <div class="row margin-top-20">
          <span class="bold x-large-font">{{
            translationService.getCharacteristicsText()
          }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getDiameterText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{ chemistry.diameter }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getWidthText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{ chemistry.width }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getHeightText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold">{{ chemistry.height }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span>{{ translationService.getWeightText() }}</span>
        </div>
        <div class="row margin-top-5">
          <span class="bold"
            >{{ chemistry.measureValue }}{{ chemistry.measureUnit }}</span
          >
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <div class="row margin-top-10">
          <span class="bold">{{
            translationService.getSafeUseInstructionsText()
          }}</span>
        </div>
        <div class="row margin-top-10">
          <a
            class="dark-link-underline"
            href="javascript:void(0)"
            (click)="showSafeUseInstructions()"
          >
            <span class="vertical-center-flex">
              <span>{{ translationService.getSafeUseInstructionsText() }}</span>
              <mat-icon class="slant-arrow-icon">call_made</mat-icon>
            </span>
          </a>
        </div>
        <div class="row margin-top-10">
          <span class="bold">{{
            translationService.getRecyclingInstructionsText()
          }}</span>
        </div>
        <div class="row margin-top-10">
          <span class="characteristic-value">
            <button
              class="button-link"
              (click)="
                downloadAndShowDocument(chemistry.recyclingInstructions ?? '')
              "
            >
              <span>{{
                translationService.getRecyclingInstructionsText()
              }}</span>
              <mat-icon class="slant-arrow-icon">call_made</mat-icon>
            </button>
          </span>
        </div>
        <div class="row margin-top-10">
          <span class="bold">{{
            translationService.getSafetyDataSheetText()
          }}</span>
        </div>
        <div class="row margin-top-10">
          <span class="characteristic-value">
            <button
              class="button-link"
              (click)="downloadAndShowDocument(chemistry.safetyDataSheet ?? '')"
            >
              <span>{{ translationService.getSafetyDataSheetText() }}</span>
              <mat-icon class="slant-arrow-icon">call_made</mat-icon>
            </button>
          </span>
        </div>
        <div class="row margin-top-10">
          <span class="bold">{{
            translationService.getIngredientsText()
          }}</span>
        </div>
        <div class="row margin-top-10">
          <a
            class="dark-link-underline"
            href="javascript:void(0)"
            (click)="openProductIngredients(chemistry.id)"
          >
            <span class="vertical-center-flex">
              <span>{{ translationService.getIngredientsText() }}</span>
              <mat-icon class="slant-arrow-icon">call_made</mat-icon>
            </span>
          </a>
        </div>
        <div class="row margin-top-10">
          <span class="bold">{{
            translationService.getSubstancesOfConcernText()
          }}</span>
        </div>
        <div class="row margin-top-10">
          <a
            class="dark-link-underline"
            href="javascript:void(0)"
            (click)="showSubstancesOfConcern()"
          >
            <span class="vertical-center-flex">
              <span>{{ translationService.getSubstancesOfConcernText() }}</span>
              <mat-icon class="slant-arrow-icon">call_made</mat-icon>
            </span>
          </a>
        </div>
        <div class="row wrap margin-top-40">
          @for (ghs of chemistry.ghsClassifications; track ghs) {
            <img
              [ngSrc]="getGhsImgPath(ghs.code)"
              height="80"
              width="80"
              [alt]="ghs.name"
              [title]="ghs.name"
              [matTooltip]="ghs.name"
            />
          }
        </div>
      </div>
    </div>
  }
}
